import { ActionTree } from 'vuex'
import { WalkthroughState } from '@/store/modules/walkthrough/index'
import { ApplicationState } from '@/store'
import { TestResultOption } from '@/store/modules/walkthrough/types/types'
import { SprayState } from '@/store/modules/walkthrough/types/pre-test/sprayState'
import { Symptoms } from '@/store/modules/walkthrough/types/pre-test/symptoms'
import { Exposure } from '@/store/modules/walkthrough/types/pre-test/exposure'
import statisticalDataService from '@/services/statistical-data-service'

export default {

  setSprayState (context, payload: SprayState) {
    context.commit('sprayState', payload)
  },

  setLang (context, payload: string) {
    context.commit('setLang', payload)
  },

  setSymptoms (context, payload: Symptoms) {
    context.commit('symptoms', payload)
  },

  setExposure (context, payload: Exposure) {
    context.commit('exposure', payload)
  },

  setSelectedOption (context, payload: TestResultOption) {
    context.commit('selectedOption', payload)
  },

  startRemainingTimeCountdown (context) {
    const handle = setTimeout(() => {
      context.commit('submitResultTimedOut', true)
    }, context.state.submit_result_timeout_in_seconds * 1000)

    context.commit('submitResultCountdownHandle', handle)
  },

  clearResults (context) {
    context.commit('sprayState', null)
    context.commit('vaccinationState', null)
    context.commit('symptoms', null)
    context.commit('exposure', null)
    context.commit('selectedOption', null)
    context.commit('submitResultTimedOut', null)
    context.commit('submitResultCountdownHandle', null)
  },

  async sendResult (context, payload: { testCompletionTime: Date, testValidityExpirationTime: Date }) {
    const userId = context.rootGetters['auth/userId']
    const organizationCode = context.rootGetters['auth/organizationCode']
    const sprayState = context.getters.sprayState
    const symptoms = context.getters.symptoms
    const exposure = context.getters.exposure
    const selectedOption = context.getters.selectedOption

    await statisticalDataService.send(
      userId,
      organizationCode,
      payload.testCompletionTime,
      payload.testValidityExpirationTime,
      sprayState,
      symptoms,
      exposure,
      selectedOption
    )
  },

  async completeTest (context) {
    const testCompletionTime = new Date()
    const testValidityExpirationTime = new Date(testCompletionTime.valueOf())
    testValidityExpirationTime.setTime(testValidityExpirationTime.getTime() + (context.state.test_validity_duration_in_hours * 60 * 60 * 1000))

    await context
      .dispatch('sendResult', { testCompletionTime, testValidityExpirationTime })
      .then(() => {
        context.commit('submitResultCountdownHandle', null)
        context.commit('testCompletionTime', testCompletionTime)
        context.commit('testValidityExpirationTime', testValidityExpirationTime)
      })
  }

} as ActionTree<WalkthroughState, ApplicationState>
